import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from "../sheet";
import AvatarInput from "./AvatarInput";
import DisplayNameInput from "./DisplayNameInput";
import NicknameInput from "./NicknameInput";

/**
 * Account settings.
 *
 * A Sheet rather than a route, matching CollectionSettingsButton — and because
 * a /settings route would permanently cost a nickname.
 */
export default function UserSettingsSheet({
  children,
  open,
  onOpenChange,
}: {
  children?: React.ReactNode;
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
}) {
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      {children && <SheetTrigger asChild>{children}</SheetTrigger>}

      <SheetContent
        className="max-sm:inset-0 max-sm:w-full max-sm:border-l-0 sm:w-[380px] sm:max-w-[380px] overflow-y-auto"
        onOpenAutoFocus={(e) => e.preventDefault()}
      >
        <SheetHeader className="px-5 pt-[18px] pb-3 border-b">
          <SheetTitle
            className="text-[18px] font-semibold text-foreground"
            style={{ fontFamily: "var(--font-serif)" }}
          >
            Account settings
          </SheetTitle>
        </SheetHeader>

        <div className="flex flex-col gap-[18px] px-5 pt-4 pb-5">
          <AvatarInput />
          <DisplayNameInput />
          <NicknameInput />
        </div>
      </SheetContent>
    </Sheet>
  );
}
